<template>
  <div class="home" safe-area-inset-bottom>
    <!--  v-if="active<3" -->
    <transition v-if="active<2||active===3" :name="'van-slide-right'">
      <router-view :key="key" class="view" />
    </transition>
    <div>
      <!-- <home v-show="active==0" /> -->
      <!-- <work v-show="active==1" /> -->
      <approval v-show="active==2" />
      <!-- <about v-show="active==3" /> -->
      <resource v-show="active==4" />
      <!-- <meeting v-if="active==5" /> -->
    <!-- <router-view :key="key" /> v-if="active<2"-->
    </div>

    <van-tabbar v-model="active" class="zindex">
      <van-tabbar-item icon="home-o" @click="roterPush(0)">首页</van-tabbar-item>
      <van-tabbar-item icon="clock-o" @click="roterPush(1)">考勤</van-tabbar-item>
      <van-tabbar-item v-show="$store.getters.approval>0" icon="certificate">审批</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="roterPush(2)">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// import home from './Home'
// import work from './Work'
import approval from './Approval'
// import about from './About'
import resource from './Resource'

export default {
  name: 'Home',
  components: {
    // home,
    // work,
    approval,
    // about,
    resource
    // meeting
  },
  data() {
    return {
      active: 0,
      transitionName: '',
      point_to_apply: this.$store.getters.point_to_apply
    }
  },

  computed: {
    key() {
      return this.$route.path
    }
  },

  created() {
    if (this.$store.getters.point_to_apply === '1') {
      this.active = 2
    }
    this.$store.dispatch('pointvuex/point_to', '0')
  },
  methods: {
    roterPush(val) {
      if (val === 1) {
        console.log('work')
        this.$router.push(
          { path: '/index/work' }
        )
      } else if (val === 0) {
        console.log('home')
        this.$router.push(
          { path: '/' }
        )
      } else if (val === 2) {
        console.log('about')
        this.$router.push(
          { path: '/index/about' }
        )
      }
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
 .view {
width: 100%;
position: absolute;
  }
	.slide-right-enter-active,
	.slide-right-leave-active,
	.slide-left-enter-active,
	.slide-left-leave-active {
will-change: transform;
transition: all 250ms;
 position: absolute;
	}
	.slide-right-enter {
opacity: 0;
transform: translate3d(-100%, 0, 0);
	}
	.slide-right-leave-active {
 opacity: 0;
 transform: translate3d(100%, 0, 0);
	}
	.slide-left-enter {
 opacity: 0;
transform: translate3d(100%, 0, 0);
	}
	.slide-left-leave-active {
opacity: 0;
transform: translate3d(-100%, 0, 0);
	}
  .zindex{
  z-index: 99;
}
</style>
